import { MessageCircle, Trash } from "lucide-react";
import Typography from "../../components/Typography/Typography";
import { Link, useNavigate } from "react-router-dom";
import ApiManager from "../../api/ApiManager";
import { useAuth } from "../../store/AuthContext/AuthContext";
import { Toaster, toast } from "react-hot-toast";

function formatTimeAgo(time) {
    // Controlla che time sia una stringa valida
    if (!time || typeof time !== 'string') {
        console.error("Valore di time non valido:", time);
        return "Tempo non disponibile";
    }

    let fixedTime = time;
    // Se il timestamp non include un offset orario, aggiungi "Z" per indicare UTC
    if (!fixedTime.endsWith("Z") && !/([+-]\d{2}:\d{2})$/.test(fixedTime)) {
        fixedTime += "Z";
    }

    // Tronca la parte decimale a soli millisecondi (3 cifre)
    fixedTime = fixedTime.replace(/(\.\d{3})\d+/, "$1");

    const now = new Date();
    const date = new Date(fixedTime);
    const diffInSeconds = Math.floor((now - date) / 1000); // differenza in secondi
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    const diffInMonths = Math.floor(diffInDays / 30);
    const diffInYears = Math.floor(diffInDays / 365);

    if (diffInSeconds < 60) {
        return diffInSeconds === 1 ? '1 secondo fa' : `${diffInSeconds} secondi fa`;
    } else if (diffInMinutes < 60) {
        return diffInMinutes === 1 ? '1 minuto fa' : `${diffInMinutes} minuti fa`;
    } else if (diffInHours < 24) {
        return diffInHours === 1 ? '1 ora fa' : `${diffInHours} ore fa`;
    } else if (diffInDays < 30) {
        return diffInDays === 1 ? '1 giorno fa' : `${diffInDays} giorni fa`;
    } else if (diffInMonths < 12) {
        return diffInMonths === 1 ? '1 mese fa' : `${diffInMonths} mesi fa`;
    } else {
        return diffInYears === 1 ? '1 anno fa' : `${diffInYears} anni fa`;
    }
}

export default function LatestSearchBox({ title, time, id, onDelete, hasDelete }) {
    const timeFormatted = formatTimeAgo(time);
    const navigate = useNavigate();
    const { getCookie } = useAuth();

    const handleDeleteChat = (event, id) => {
        event.stopPropagation();

        const api = new ApiManager();
        const projectId = getCookie("project_id");
        const id_token = getCookie("id_token");

        console.log(`/search/delete?project_id=${projectId}&chat_id=${id}`);
        console.log(`Bearer ${id_token}`);

        api.delete(`/search/delete?project_id=${projectId}&chat_id=${id}`, null, {
            headers: {
                Authorization: `Bearer ${id_token}`,
            },
        })        
            .then((response) => {
            if (response.data && response.data.statusCode === 200) {
                console.log("Chat eliminata con successo:", response.data);
                toast.success("Chat eliminata con successo");
                onDelete(id);
            } else {
                console.error("Errore nell'eliminazione della chat:", response.data);
                toast.error("Errore nell'eliminazione della chat");

            }
        })
        .catch((error) => {
            console.error("Errore nella chiamata API:", error);
            toast.error("Errore nell'eliminazione della chat");
        });
};

return (
    <div
        className="w-full py-4 px-6 bg-white text-black border-2 border-gray-100 hover:border-gray-200 active:border-black rounded-[8px] cursor-pointer"
        onClick={() => navigate(`/client/research?chat=${id}`)}
    >
        <Toaster />
        <div className="flex flex-col gap-3">
            <div className="flex justify-between">
                <MessageCircle size={20} />
                {hasDelete && (
                    <div
                        className="text-error"
                        onClick={(e) => handleDeleteChat(e, id)}
                    >
                        <Trash size={20} />
                    </div>
                )}
            </div>
            <div className="flex flex-col gap-2">
                <Typography size="12" weight="sb">
                    {title}
                </Typography>
                <Typography size="12" weight="md" color="gray-600">
                    Ultimo messaggio {timeFormatted}
                </Typography>
            </div>
        </div>
    </div>
);
}
